module.exports = ".image{width:30rem}.message{margin-bottom:2.5rem}"